import script from "./CardData.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardData.vue?vue&type=script&lang=ts&setup=true"

import "./CardData.vue?vue&type=style&index=0&id=245f0166&lang=css"

const __exports__ = script;

export default __exports__